import { render } from "./ImportMerchant.vue?vue&type=template&id=2023c33c"
import script from "./ImportMerchant.vue?vue&type=script&lang=js"
export * from "./ImportMerchant.vue?vue&type=script&lang=js"

import "./ImportMerchant.vue?vue&type=style&index=0&id=2023c33c&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__